module.exports = __webpack_public_path__ + "media/social/social-6-e93728f4.jpg";